<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineOptions({ name: 'CheckinStepFooter' });

withDefaults(
  defineProps<{
    showPrevious?: boolean;
    nextDisabled?: boolean;
  }>(),
  {
    showPrevious: true,
    nextDisabled: false
  }
);

const emit = defineEmits<{
  previous: [];
  next: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="d-flex gap-3">
    <v-btn
      v-if="showPrevious"
      class="flex-grow-1 border--color-neutral-40"
      variant="outlined"
      prepend-icon="mdi-arrow-left"
      data-testid="comet-step-previous"
      @click="emit('previous')">
      {{ t('common.previous') }}
    </v-btn>
    <v-btn
      class="flex-grow-1"
      color="primary"
      append-icon="mdi-arrow-right"
      :disabled="nextDisabled"
      data-testid="comet-step-next"
      @click="emit('next')">
      {{ t('common.next') }}
    </v-btn>
  </div>
</template>
